import React from "react";
import {
  Box,
  TextField,
  InputAdornment,
  MenuItem,
  FormGroup,
  Checkbox,
  FormControlLabel,
  Popover,
  CircularProgress,
  Button,
  Chip,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "../../../assets/filter.svg";
import TabsNav from "../../analytics/header/BatchTabsNav";
import "./review.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CURRENT_TEMPLATE_VERSION_LABEL } from "../../../constants/investigationAnalysisReview";

export default function LimitsListHeader({
  text,
  buttonText,
  onButtonClick,
  filterOptionsGroup1,
  filterOptionsGroup2,
  selectedFilters,
  handleCheckboxChange,
  isButton = false,
  handleSearch,
  search,
  handleClickFilter,
  anchorFilter,
  handleCloseFilter,
  selectedCheck,
  onDownloadClick,
  viewAuditLogs,
  viewLogs,
  onBackClick,
  placeholder = "Search",
  is_multi_approve = false,
  multipleApprove,
  approveMulti,
  downloadExcelTemp,
  showBackOnList,
  onBackClickForNavBatchId,
  backButtonText = "Back to Charts",
  canViewAuditTrail = false,
  canDownloadTemplate = false,
  canUploadData = false,
  currentTemplateVersion,
}) {
  const openFilter = Boolean(anchorFilter);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        borderBottom: "1px solid #e0e0e0",
        py: 1,
        px: 1,
        gap: 1,
        flexWrap: "nowrap",
        overflowX: "auto",
        minHeight: 52,
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {" "}
      {viewLogs ? (
        <>
          {" "}
          <Button
            startIcon={<ArrowBackIcon />}
            sx={{
              textTransform: "none",
              borderRadius: "20px !important",
              paddingX: 2,
              paddingY: 0.2,
              backgroundColor: "#E9EAEB",
              color: "Black",
            }}
            onClick={onBackClick}
          >
            Back
          </Button>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexShrink: 0,
          }}
        >
          {showBackOnList && (
            <Button
              className="review-back-to-batches-button"
              startIcon={<ArrowBackIcon fontSize="small" />}
              onClick={onBackClickForNavBatchId}
              variant="outlined"
            >
              {backButtonText}
            </Button>
          )}
          <TabsNav />
        </Box>
      )}
      {currentTemplateVersion !== undefined &&
        currentTemplateVersion !== null &&
        !viewLogs && (
          <Chip
            className="current-template-version"
            label={`${CURRENT_TEMPLATE_VERSION_LABEL}: ${currentTemplateVersion}`}
            variant="outlined"
          />
        )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          flexWrap: "nowrap",
          gap: 1,
          minWidth: 0,
          ml: "auto",
          flexShrink: 1,
          "& .MuiButton-root": {
            height: 36,
            minHeight: 36,
            whiteSpace: "nowrap",
            flexShrink: 0,
          },
        }}
      >
        <Box sx={{ width: "clamp(180px, 18vw, 270px)", flexShrink: 1 }}>
          <TextField
            fullWidth
            size="small"
            placeholder={placeholder}
            title={placeholder}
            variant="outlined"
            value={search}
            onChange={handleSearch}
            sx={{ "& .MuiInputBase-root": { height: 36 } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box display="flex" alignItems="center" gap={1} flexWrap="nowrap">
          <Button
            size="small"
            onClick={handleClickFilter}
            startIcon={<img src={FilterListIcon} alt="Filter" />}
            sx={{
              color: "black",
              textTransform: "none",
              fontSize: 14,
              fontWeight: 400,
            }}
          >
            Filter
          </Button>
          <Popover
            id={1}
            open={openFilter}
            anchorEl={anchorFilter}
            onClose={handleCloseFilter}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            sx={{ mt: 1 }}
          >
            <Box p={2} minWidth={150}>
              {/* <Typography fontSize={14} mb={1}>
              Filter By:
            </Typography> */}

              <FormGroup>
                {filterOptionsGroup1?.map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={selectedFilters?.includes(option)}
                        onChange={() => handleCheckboxChange(option)}
                      />
                    }
                    label={option}
                  />
                ))}
                {filterOptionsGroup2?.length > 0 && (
                  <hr style={{ width: "100%" }}></hr>
                )}
                {filterOptionsGroup2?.map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={selectedFilters?.includes(option)}
                        onChange={() => handleCheckboxChange(option)}
                      />
                    }
                    label={option}
                  />
                ))}
              </FormGroup>
            </Box>
          </Popover>

          {is_multi_approve && (
            <Button
              variant={"contained"}
              disabled={!selectedCheck?.length > 0 || approveMulti?.loading}
              startIcon={
                approveMulti?.loading ? (
                  <CircularProgress size={16} sx={{ color: "#fff" }} />
                ) : (
                  ""
                )
              }
              sx={{
                // backgroundColor: "#154D8F",
                textTransform: "none",
                // "&:hover": { backgroundColor: "#1565c0" },
                fontSize: 14,
                fontWeight: 400,
              }}
              onClick={multipleApprove}
            >
              Approve
            </Button>
          )}
          {isButton && (
            <>
              {" "}
              {canViewAuditTrail && <Button
                variant={!viewLogs ? "outlined" : "contained"}
                sx={{
                  // backgroundColor: "#154D8F",
                  textTransform: "none",
                  // "&:hover": { backgroundColor: "#1565c0" },
                  fontSize: 14,
                  fontWeight: 400,
                }}
                onClick={viewAuditLogs}
                size="small"
              >
                Audit Trail
              </Button>}
              {canDownloadTemplate && <Button
                variant="contained"
                size="small"
                startIcon={
                  downloadExcelTemp?.loading ? (
                    <CircularProgress size={16} sx={{ color: "#fff" }} />
                  ) : (
                    <DownloadIcon />
                  )
                }
                onClick={onDownloadClick}
                sx={{
                  backgroundColor: "#3882DB",
                  textTransform: "none",
                  minHeight: "36px",
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
              >
                {downloadExcelTemp?.loading
                  ? "Template Downloading"
                  : "Template Download"}
              </Button>}
              {canUploadData && <Button
                size="small"
                variant="contained"
                startIcon={<AddIcon />}
                onClick={onButtonClick}
                sx={{
                  backgroundColor: "#3882DB",
                  textTransform: "none",
                  minHeight: "36px",
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
              >
                {buttonText}
              </Button>}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
